import { z } from "zod";

export const activeStreamSchema = z.object({
  _id: z.string(),
  userId: z.string(),
  seriesId: z.string(),
  episodeId: z.string(),
  sessionId: z.string(),
  startedAt: z.coerce.date(),
  lastSeenAt: z.coerce.date(),
  ipHash: z.string().optional(),
});
export type ActiveStream = z.infer<typeof activeStreamSchema>;

export const watchProgressSchema = z.object({
  _id: z.string(),
  userId: z.string(),
  episodeId: z.string(),
  seriesId: z.string(),
  positionSec: z.number().nonnegative(),
  durationSec: z.number().nonnegative(),
  completed: z.boolean().default(false),
  completedAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date(),
});
export type WatchProgress = z.infer<typeof watchProgressSchema>;
